// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import DashboardComponents from './components';
// assets
//

// ----------------------------------------------------------------------

export default function MarketingDashboard() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <DashboardComponents />
        </Container >
    );
}
